module.exports = "products: [],\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/Wizard/Snippet/snippets/transactionProducts.html
// module id = 2160
// module chunks = 0